import { render, staticRenderFns } from "./saveViewDefinition.vue?vue&type=template&id=91d95682&scoped=true"
import script from "./saveViewDefinition.vue?vue&type=script&lang=js"
export * from "./saveViewDefinition.vue?vue&type=script&lang=js"
import style0 from "./saveViewDefinition.vue?vue&type=style&index=0&id=91d95682&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91d95682",
  null
  
)

export default component.exports